/**
 * Payer-side fee gross-up. Mirrors backend quick_split_router.compute_payer_fee
 * so UI previews match exactly what backend will charge.
 *
 * Rules (confirmed product policy):
 *  - Card / Apple Pay / Link: 2.9% + $0.30
 *  - ACH / bank transfer: 0.8%, capped at $5.00
 *  - Fee is always rounded UP to the next whole cent (no subsidy)
 *  - Host receives the exact split; payer covers the fee
 */
export function computePayerFee(splitCents, method) {
  const m = (method === 'ach') ? 'ach' : 'card';
  if (m === 'ach') {
    let total = Math.ceil((splitCents * 1000) / 992);
    let fee = total - splitCents;
    if (fee > 500) { fee = 500; total = splitCents + fee; }
    return { total, fee, method: 'ach' };
  }
  const total = Math.ceil(((splitCents + 30) * 1000) / 971);
  const fee = total - splitCents;
  return { total, fee, method: 'card' };
}

export const METHOD_LABEL = {
  card: 'Card',
  ach: 'Bank transfer',
};
